import * as React from 'react';
import { Route, Switch } from 'react-router';
import { ToxnotReactComponentPaths } from './components/core/ToxnotReactComponentPaths';
import { CreateAndEditSurveyComponentPaths } from './components/Survey/SurveyComponentPaths';
import StartHome from './components/Start/StartHome';
import SharedMaterialsMain from './components/SharedMaterials/SharedMaterialsMain';
import TaskManagementMain from './components/TaskManagement/TaskManagementMain';
import { XmlExportComponentPaths } from './components/XmlExport/XmlExportComponentPaths';
import Ipc1752aExportView from './components/XmlExport/Ipc1752aExportView';
import { BulkReportComponentPaths } from './components/BulkReport/BulkReportComponentPath';
import BulkReport from './components/BulkReport/BulkReport';
import { TaskManagementComponentPaths } from './components/TaskManagement/TaskManagementComponentPaths';
import MyCustomersMain from './components/Customers/MyCustomersMain';
import { SurveyMain } from "./components/Survey/SurveyMain";
import Consult from './components/Consult/Consult';

import './custom.css'
import NewsMain from './components/News/NewsMain';
import RegulationLibrary from './components/Regulations/RegulationLibrary';
import RegulationsDetailLibrary from './components/Regulations/RegulationsDetailLibrary';
import ObtainmentReports from "./components/ObtainmentReports/ObtainmentReports";

/**
 * Component that dynamically adds Toxnot branded styles to the DOM.
 */
export class ToxnotBranded extends React.PureComponent {
    private static readonly rootClass = "tn-app-html";
    private static readonly bodyClass = "tn-app-html-body";

    private static findRoot(): HTMLHtmlElement {
        return document.getElementsByTagName("html")[0]; // '0' to assign the first (and only `HTML` tag)
    }

    public componentDidMount() {
        ToxnotBranded.findRoot().setAttribute("class", ToxnotBranded.rootClass);
        document.body.classList.add(ToxnotBranded.bodyClass);
    }

    public componentWillUnmount() {
        ToxnotBranded.findRoot().removeAttribute("class");
        document.body.classList.remove(ToxnotBranded.bodyClass);
    }

    public render() {
        return (
            <Switch>
                <Route exact={true} path={ToxnotReactComponentPaths.Consult} component={Consult} />
                <Route path={ToxnotReactComponentPaths.StartPath} component={StartHome} />
                <Route path={ToxnotReactComponentPaths.BaseNewsPath} component={NewsMain} />
                <Route path={ToxnotReactComponentPaths.BaseRegulationPath} component={RegulationLibrary} />
                <Route path={ToxnotReactComponentPaths.BaseRegulationDetailsPath} component={RegulationsDetailLibrary} />
                <Route exact={true} path={ToxnotReactComponentPaths.ObtainmentReportsPath} component={ObtainmentReports} />
                <Route path={ToxnotReactComponentPaths.BaseSharedMaterialsPath} component={SharedMaterialsMain} />
                <Route exact={true} path={XmlExportComponentPaths.Ipc1752aPath} component={Ipc1752aExportView} />
                <Route path={ToxnotReactComponentPaths.BaseSurveyPath} component={SurveyMain} />
                <Route path={ToxnotReactComponentPaths.BaseSurveysPath} component={SurveyMain} />
                <Route exact={true} path={BulkReportComponentPaths.BasePath} component={BulkReport} />
                <Route exact={true} path={TaskManagementComponentPaths.BasePath} component={TaskManagementMain} />
                <Route exact={true} path={TaskManagementComponentPaths.BasePath + "/:taskId"} component={TaskManagementMain} />
                <Route path={ToxnotReactComponentPaths.MyCustomersBasePath} component={MyCustomersMain} />
            </Switch>
        );
    }
}
